import React, { useRef } from 'react'
import {
  Control,
  RegisterOptions,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form'

import s from './styles.module.scss'

import CustomCalendar from './custom-calendar/CustomCalendar'
import { ModalPicker, ModalPickerRef } from '../modal-picker'
import { Icon, IconSvg } from '../../atoms'
import useDateFormatter from '../../../lib/hooks/useDateFormatter'

const DatesSelectField = ({
  placeholder = 'Dates',
  control,
  name,
  rules,
  getValues,
  setValue,
  displayPastDates = false,
  singleDate = false,
  style,
  isLeftAligned = false,
}: {
  placeholder?: string
  control: Control<any, any>
  name: string
  rules: Omit<
    RegisterOptions<any, any>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >
  getValues?: UseFormGetValues<any>
  setValue?: UseFormSetValue<any>
  displayPastDates?: boolean
  singleDate?: boolean
  style?: React.CSSProperties
  isLeftAligned?: boolean
}) => {
  const [activeStartDate, setActiveStartDate] = React.useState<Date>(new Date())
  const ref = useRef<ModalPickerRef>(null)
  const dateFormatter = useDateFormatter()

  return (
    <div style={style}>
      <ModalPicker
        dataGtm='date_arrivee_depart'
        dataMixpanel={{ name: 'date_arrivee_depart' }}
        control={control}
        rules={rules}
        name={name}
        ref={ref}
        mobileTitle='Sélectionnez vos dates'
        isCentered={false}
        isLeftAligned={isLeftAligned}
        renderContentModal={(field) => (
          <div>
            <CustomCalendar
              startDate={field.value?.startDate}
              endDate={!singleDate ? field.value?.endDate : null}
              setDate={({ startDate, endDate }) => {
                field.onChange({
                  startDate,
                  endDate: !singleDate ? endDate : undefined,
                })
              }}
              closeModal={() =>
                ref && ref.current && ref.current.setShowModal(false)
              }
              activeStartDate={activeStartDate}
              setActiveStartDate={setActiveStartDate}
              displayPastDates={displayPastDates}
            />
          </div>
        )}
        onClose={() => {
          if (getValues && setValue && !singleDate) {
            if (
              getValues(`${name}.startDate`) &&
              getValues(`${name}.endDate`) === undefined
            ) {
              setValue(name, undefined)
            }
          }
        }}
        renderInputField={(field) => {
          return (
            <div className={s.containerInputField}>
              <div className={s.inputField}>
                {!field.value?.startDate || !field.value?.endDate ? (
                  <>
                    <span className={s.lowOpacity}>{placeholder}</span>
                    <Icon
                      name='arrow-down'
                      size={12}
                      style={{ opacity: '0.5', marginRight: '6px' }}
                    />
                  </>
                ) : (
                  <>
                    <span className={s.dates}>
                      {dateFormatter.formatDateRange({
                        startDate: field.value.startDate,
                        endDate: field.value.endDate,
                        formatString: 'dayMonth',
                      })}
                    </span>
                    <IconSvg.Close
                      onClick={(e) => {
                        field.onChange({
                          startDate: undefined,
                          endDate: undefined,
                        })
                        e.stopPropagation()
                      }}
                      style={{
                        height: 10,
                        width: 10,
                        opacity: '0.5',
                        marginRight: '6px',
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

export default DatesSelectField
